import { ANALYTICS_REPORTS_TABS_ID } from '../../useAnalyticsTabs';

export function enableSmartLabelledAnalyticsTabs(config: any) {
  let tabs = config.tabs?.[ANALYTICS_REPORTS_TABS_ID]?.items ?? [];
  for (const tab of tabs) {
    if (tab.usingSmartLabel === undefined) {
      tab.usingSmartLabel = true;
    }
  }
  tabs = tabs.filter((tab: any) => tab.type !== 'dailyOverview');
  if (config.tabs?.[ANALYTICS_REPORTS_TABS_ID]?.items != null) {
    config.tabs[ANALYTICS_REPORTS_TABS_ID].items = tabs;
  }
}
